export interface ThirdPartyPropertyIds {
  googleAnalyticsId: string;
  googleTagManagerId: string;
}

export interface ThirdPartyScriptInstaller {
  safeInstall: (config: ThirdPartyPropertyIds) => void;
  script: (config: ThirdPartyPropertyIds) => void;
}

export enum KnownThirdPartyScripts {
  GoogleTagManager = "googleTagManager"
}

export interface ThirdPartyScript {
  name: KnownThirdPartyScripts;
  enabled: boolean;
  scriptUrl: string;
}
